import { BlogSection } from '@/types/blog';

export const kernregeln: BlogSection = {
  id: 'kernregeln',
  title: 'Eine Auswahl der Kernregeln',
  content: `
    <p class="mb-6">
      Meine Zieldirektive ist der strategische Kompass. Die folgenden Regeln sind das taktische Handbuch für die tägliche Reise.
    </p>
    
    <h3 class="text-2xl font-semibold text-joerg-800 mt-8 mb-4">Regel #1: Gesundheit als finale Metrik</h3>
    <p class="mb-4">
      Gesundheit ist kein "Nice-to-have", sondern die finale Metrik. Das führt zu einer Konsequenz, die oft als unternehmerisches Tabu gilt: <strong>Ich arbeite nicht mit jedem.</strong> Ich lehne aktiv Anfragen ab, wenn ein Projekt gegen meine ethischen oder humanistischen Standards verstößt. Das ist keine Arroganz, sondern systemische Selbsterhaltung. Nennen wir es "energetische Budgetverwaltung".
    </p>
    
    <h3 class="text-2xl font-semibold text-joerg-800 mt-8 mb-4">Regel #2: Atomare Schritte statt großer Sprünge (Ministeps)</h3>
    <p class="mb-4">
      Große Ziele können lähmen. Der innere Autopilot, dessen Lieblingszielort "Morgen" ist, schaltet schnell auf Prokrastination. Diese Regel verbietet große, vage Aufgaben. Jedes Ziel wird dekonstruiert, bis der nächste Schritt so klein ist, dass er keinen Widerstand mehr erzeugt. Nicht "Homepage texten", sondern "Den ersten Satz für die 'Über mich'-Seite schreiben".
    </p>
    
    <h3 class="text-2xl font-semibold text-joerg-800 mt-8 mb-4">Regel #3: Die Selbsteinschätzung hat Vorrang</h3>
    <p class="mb-4">
      Externe Metriken – Umsatz, Likes, Erwartungen – sind nur das digitale Rauschen einer Welt, die Applaus für's Beschäftigtsein vergibt. Diese Regel besagt, dass die ehrliche, interne Einschätzung meines eigenen Zustands (Energie, Fokus) immer Vorrang vor externem Druck hat. Meldet das System "Energie bei 20%", ist es Zeit für eine Pause, nicht für einen weiteren Push.
    </p>
  `
};
